import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Badge from '../../UniformComponents/Badge'
import Panel from '../../UniformComponents/Panel'
import PanelFooter from '../../UniformComponents/PanelFooter'
import PanelHeader from '../../UniformComponents/PanelHeader'
import Typography from '../../UniformComponents/Typography'
import Standard from './Standard'
import SelfCertify from './SelfCertify'
import CerticationStore from './CertificationStore'

import './style.scss'
import LinkedIn from './modal/LinkedIn'
import Certificate from './Certificate'
import KpiModal from './KpiModal'
import LinkedinWarning from './LinkedinWarning'

@observer
class Certification extends Component {
    constructor(props) {
        super(props)

        this.certificationStore = new CerticationStore(this.props.store)
    }

    componentDidMount() {
        this.certificationStore.getCertification()
    }

    certificateIcon = () => (
        <img src={`${process.env.CDN_URL}/images/certificationBadge.png`} alt="certification badge" />
    )

    surveyStandardsMet = () => {
        const { automatic, isLoading } = this.certificationStore

        return !isLoading && automatic.filter(({ passed }) => !passed).length === 0
    }

    verifiedFooter = (rules) => {
        const numberPassed = rules.filter(({ passed }) => passed).length
        const totalNumber = rules.length

        const className = (numberPassed < totalNumber)
            ? 'failed'
            : 'passed'

        return (
            <div className={className}>
                <Typography type="h4">
                    {i18n.t('certification.ui.verified')}
                    {' '}
                    {numberPassed}
                    {' / '}
                    {totalNumber}
                </Typography>
            </div>
        )
    }

    render() {
        const { certificationStore, surveyStandardsMet } = this
        const { standardIcon, includedKpis } = certificationStore

        return (
            <div
                id="surveyCertification"
                className={`${process.env.USE_NEW_HEADER_UI ? 'survey-view-wrapper' : ''}`}
            >
                <div className="main">
                    <div
                        className="header"
                    >
                        <div className="certification-header">
                            {this.certificateIcon()}
                            <div className="title-wrapper">
                                <Typography type="h4">{i18n.t('certification.ui.title')}</Typography>
                                <Badge
                                    type={certificationStore.isCertified ? 'success' : 'error'}
                                >
                                    {certificationStore.isCertified ? 'verified' : 'unverified'}
                                </Badge>
                            </div>
                        </div>
                        <div className="description">
                            <Typography type="b">{i18n.t('certification.ui.description')}</Typography>
                            <Typography type="p">{i18n.t('certification.ui.description2')}</Typography>
                        </div>
                        <div className="allianceLogo">
                            <Typography type="b">{i18n.t('certification.certificate.auditedBy')}</Typography>
                            <img
                                crossOrigin="anonymous"
                                src={`${process.env.CDN_URL}/images/allianceLogo.png`}
                                alt="Alliance for Audited Media Logo"
                            />
                        </div>
                    </div>
                    <div className="panel-wrapper">
                        {surveyStandardsMet() ? (
                            <div className="certificationWarning success">
                                <i className="fa-regular fa-circle-check" />
                                <Typography type="p">{i18n.t('certificationSidebar.passed')}</Typography>
                            </div>
                        ) : (
                            <div className="certificationWarning warning">
                                <i className="fa-sharp fa-light fa-triangle-exclamation" />
                                <Typography type="p">{i18n.t('certificationSidebar.warning')}</Typography>
                            </div>
                        )}
                        <div className="panels">
                            <Panel className="certification-panel">
                                <PanelHeader noDivider>
                                    <Typography type="h3">{i18n.t('certification.ui.automatic.title')}</Typography>
                                    <Typography type="p">
                                        {i18n.t('certification.ui.automatic.description')}
                                    </Typography>
                                </PanelHeader>
                                <div className="panelBody">
                                    {certificationStore.automatic.map((standard, i) => (
                                        <Standard
                                            key={standard.type}
                                            certificationStore={certificationStore}
                                            standard={standard}
                                            index={i}
                                            icon={standardIcon(standard)}
                                        />
                                    ))}
                                </div>
                                <PanelFooter noDivider>
                                    {this.verifiedFooter(certificationStore.automatic)}
                                </PanelFooter>
                            </Panel>
                            {surveyStandardsMet() ? (
                                <Panel className="certification-panel">
                                    <PanelHeader noDivider>
                                        <Typography type="h3">
                                            {i18n.t('certification.ui.selfAssessed.title')}
                                        </Typography>
                                        <Typography type="p">
                                            {i18n.t('certification.ui.selfAssessed.description')}
                                        </Typography>
                                    </PanelHeader>
                                    <div className="panelBody">
                                        {
                                            certificationStore.selfAssessed.map((selfSelectQuestion, i) => (
                                                <SelfCertify
                                                    key={selfSelectQuestion.id}
                                                    certificationStore={certificationStore}
                                                    selfSelectQuestion={selfSelectQuestion}
                                                    index={i}
                                                />
                                            ))
                                        }
                                    </div>
                                    <PanelFooter noDivider>
                                        {this.verifiedFooter(certificationStore.selfAssessed)}
                                    </PanelFooter>
                                </Panel>
                            ) : null}
                        </div>
                        <div className="download-and-share">
                            <div
                                className={`download ${!certificationStore.isCertified ? 'disabled' : ''}`}
                                onClick={() => {
                                    if (!certificationStore.isCertified) return
                                    certificationStore.toggleShowKpiModal('download')
                                }}
                            >
                                {this.certificateIcon()}
                                <div className="certificate-text">
                                    <Typography type="h4">{i18n.t('certification.ui.download.title')}</Typography>
                                    <Typography type="tiny">
                                        {i18n.t('certification.ui.download.description')}
                                    </Typography>
                                </div>
                            </div>
                            <div className="linkedin-wrapper">
                                <Typography type="b">
                                    {i18n.t('certification.ui.shareOn')}
                                </Typography>
                                <div
                                    className={`download linkedin ${!certificationStore.isCertified ? 'disabled' : ''}`}
                                    onClick={() => {
                                        if (!certificationStore.isCertified) return
                                        certificationStore.toggleShowKpiModal('linkedin')
                                    }}
                                >
                                    <i className="fab fa-linkedin" />
                                </div>
                                <Certificate
                                    certificationStore={certificationStore}
                                    includedKpis={includedKpis}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <LinkedIn certificationStore={certificationStore} />
                <KpiModal certificationStore={certificationStore} />
                <LinkedinWarning certificationStore={certificationStore} />
            </div>
        )
    }
}

export default Certification
